export default __webpack_public_path__ + "static/404-page-lyscicrates-prize-mouth-v2-c9fbf9f67ec7183e4a4c15f2a586003d.png";